'use strict';

import Vue      from 'vue';
import options  from './index.vue';
import styleBase  from './styleBase.vue';
import fission  from './fission.vue';
import pop  from './pop.vue';
import pushPop  from './pushPop.vue';

Vue.component('tg-coupon', options);
Vue.component('tg-coupon-base', styleBase);
Vue.component('tg-coupon-fission', fission);
Vue.component('tg-coupon-pop', pop);
Vue.component('tg-coupon-push-pop', pushPop);